export default __webpack_public_path__ + "static/media/Corp-money.1de7e98b.svg";